import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  en: {
    // Navigation
    admin: "Admin",
    bookNow: "Book Now",
    
    // Hero
    checkAvailability: "Check Availability",
    
    // Property Overview
    mediterraneanParadise: "Your Mediterranean Paradise",
    bedrooms: "Bedrooms",
    bathrooms: "Bathrooms",
    maxGuests: "Max Guests",
    sqm: "SQM",
    
    // Amenities
    amenitiesFeatures: "Amenities & Features",
    pool: "Pool",
    wifi: "WiFi",
    airConditioning: "Air Conditioning",
    kitchen: "Fully Equipped Kitchen",
    terrace: "Terrace",
    parking: "Parking",
    tv: "TV",
    washingMachine: "Washing Machine",
    nearBeach: "Near Beach (10 min walk)",
    nearShopping: "Near Shopping Centre (15 min walk)",
    
    // Gallery
    propertyGallery: "Property Gallery",
    
    // Location
    perfectLocation: "Perfect Location",
    locationDescription: "C. Parana, 2, La Zenia - Walking distance to beach, restaurants, and shopping",
    beach: "La Zenia Beach",
    boulevard: "La Zenia Boulevard",
    restaurants: "Restaurants & Cafés",
    airport: "Alicante Airport",
    
    // Booking Form
    requestBooking: "Request a Booking",
    checkInDate: "Check-in Date",
    checkOutDate: "Check-out Date",
    selectDate: "Select date",
    calculatingPrice: "Calculating price...",
    night: "night",
    nights: "nights",
    totalPrice: "Total Price",
    minimumStay: "Minimum Stay",
    minimumStayWarning: "Please select at least {min} nights for these dates.",
    priceIncludes: "Price includes {nights} {nightWord} at €{price}/night",
    numberOfGuests: "Number of Guests",
    guest: "Guest",
    guests: "Guests",
    yourName: "Your Name",
    email: "Email",
    phone: "Phone",
    specialRequests: "Special Requests (Optional)",
    sendingRequest: "Sending request...",
    bookNowPrice: "Book Now - €{price}",
    submitBookingRequest: "Submit Booking Request",
    
    // Messages
    selectDates: "Please select check-in and check-out dates",
    minimumNightsRequired: "Minimum stay is {min} nights for these dates",
    bookingSuccess: "Booking request sent! Total price: €{price}",
    bookingFailed: "Booking failed. Please try again.",
    datesNotAvailable: "Selected dates are not available",
    bookedDatesInfo: "Red dates are already booked and unavailable",
    
    // Footer
    allRightsReserved: "All rights reserved",
    
    // Loading
    loading: "Loading...",
  },
  is: {
    // Navigation
    admin: "Stjórnandi",
    bookNow: "Bóka núna",
    
    // Hero
    checkAvailability: "Athuga laust",
    
    // Property Overview
    mediterraneanParadise: "Þitt Miðjarðarhafslæga paradís",
    bedrooms: "Svefnherbergi",
    bathrooms: "Baðherbergi",
    maxGuests: "Hámarksgestir",
    sqm: "FM",
    
    // Amenities
    amenitiesFeatures: "Þægindi og eiginleikar",
    pool: "Sundlaug",
    wifi: "WiFi",
    airConditioning: "Loftkæling",
    kitchen: "Fullbúið eldhús",
    terrace: "Verönd",
    parking: "Bílastæði",
    tv: "Sjónvarp",
    washingMachine: "Þvottavél",
    nearBeach: "Nálægt strönd (10 mín ganga)",
    nearShopping: "Nálægt verslunarmiðstöð (15 mín ganga)",
    
    // Gallery
    propertyGallery: "Myndagallerí",
    
    // Location
    perfectLocation: "Fullkomin staðsetning",
    locationDescription: "C. Parana, 2, La Zenia - Stutt göngufjarlægð frá strönd, veitingastöðum og verslunum",
    beach: "La Zenia strönd",
    boulevard: "La Zenia Boulevard",
    restaurants: "Veitingastaðir og kaffihús",
    airport: "Alicante flugvöllur",
    
    // Booking Form
    requestBooking: "Senda bókunarbeiðni",
    checkInDate: "Innritunardagur",
    checkOutDate: "Útritunardagur",
    selectDate: "Veldu dagsetningu",
    calculatingPrice: "Reikna verð...",
    night: "nótt",
    nights: "nætur",
    totalPrice: "Heildarverð",
    minimumStay: "Lágmarks dvöl",
    minimumStayWarning: "Vinsamlegast veldu að minnsta kosti {min} nætur fyrir þessar dagsetningar.",
    priceIncludes: "Verðið inniheldur {nights} {nightWord} á €{price}/nótt",
    numberOfGuests: "Fjöldi gesta",
    guest: "Gestur",
    guests: "Gestir",
    yourName: "Nafnið þitt",
    email: "Netfang",
    phone: "Sími",
    specialRequests: "Sérstakar óskir (valfrjálst)",
    sendingRequest: "Sendir beiðni...",
    bookNowPrice: "Bóka núna - €{price}",
    submitBookingRequest: "Senda bókunarbeiðni",
    
    // Messages
    selectDates: "Vinsamlegast veldu inn- og útskráningardagsetningar",
    minimumNightsRequired: "Lágmarks dvöl er {min} nætur fyrir þessar dagsetningar",
    bookingSuccess: "Bókunarbeiðni send! Heildarverð: €{price}",
    bookingFailed: "Bókun mistókst. Vinsamlegast reyndu aftur.",
    datesNotAvailable: "Valdar dagsetningar eru ekki lausar",
    bookedDatesInfo: "Rauðir dagar eru þegar bókaðir og ekki laus",
    
    // Footer
    allRightsReserved: "Öll réttindi áskilin",
    
    // Loading
    loading: "Hleður...",
  },
  lt: {
    // Navigation
    admin: "Administratorius",
    bookNow: "Rezervuoti dabar",
    
    // Hero
    checkAvailability: "Tikrinti prieinamumą",
    
    // Property Overview
    mediterraneanParadise: "Jūsų Viduržemio jūros rojus",
    bedrooms: "Miegamieji",
    bathrooms: "Vonios kambariai",
    maxGuests: "Maks. svečių",
    sqm: "KV.M",
    
    // Amenities
    amenitiesFeatures: "Patogumai ir ypatybės",
    pool: "Baseinas",
    wifi: "WiFi",
    airConditioning: "Oro kondicionierius",
    kitchen: "Pilnai įrengta virtuvė",
    terrace: "Terasa",
    parking: "Parkavimas",
    tv: "Televizorius",
    washingMachine: "Skalbimo mašina",
    nearBeach: "Netoli paplūdimio (10 min pėsčiomis)",
    nearShopping: "Netoli prekybos centro (15 min pėsčiomis)",
    
    // Gallery
    propertyGallery: "Nuotraukų galerija",
    
    // Location
    perfectLocation: "Puiki vieta",
    locationDescription: "C. Parana, 2, La Zenia - Pėsčiomis iki paplūdimio, restoranų ir parduotuvių",
    beach: "La Zenia paplūdimys",
    boulevard: "La Zenia Boulevard",
    restaurants: "Restoranai ir kavinės",
    airport: "Alikantės oro uostas",
    
    // Booking Form
    requestBooking: "Pateikti rezervacijos užklausą",
    checkInDate: "Atvykimo data",
    checkOutDate: "Išvykimo data",
    selectDate: "Pasirinkite datą",
    calculatingPrice: "Skaičiuojama kaina...",
    night: "naktis",
    nights: "naktys",
    totalPrice: "Bendra kaina",
    minimumStay: "Minimalus apsistojimas",
    minimumStayWarning: "Prašome pasirinkti bent {min} naktis šioms datoms.",
    priceIncludes: "Kaina apima {nights} {nightWord} po €{price}/naktį",
    numberOfGuests: "Svečių skaičius",
    guest: "Svečias",
    guests: "Svečiai",
    yourName: "Jūsų vardas",
    email: "El. paštas",
    phone: "Telefonas",
    specialRequests: "Specialūs pageidavimai (neprivaloma)",
    sendingRequest: "Siunčiama užklausa...",
    bookNowPrice: "Rezervuoti dabar - €{price}",
    submitBookingRequest: "Pateikti rezervacijos užklausą",
    
    // Messages
    selectDates: "Prašome pasirinkti atvykimo ir išvykimo datas",
    minimumNightsRequired: "Minimalus apsistojimas šioms datoms yra {min} naktys",
    bookingSuccess: "Rezervacijos užklausa išsiųsta! Bendra kaina: €{price}",
    bookingFailed: "Rezervacija nepavyko. Bandykite dar kartą.",
    datesNotAvailable: "Pasirinktos datos nėra laisvos",
    bookedDatesInfo: "Raudonos datos jau užimtos ir nepasiekiamos",
    
    // Footer
    allRightsReserved: "Visos teisės saugomos",
    
    // Loading
    loading: "Kraunama...",
  },
};

// Amenity translation mapping
export const amenityTranslations = {
  en: {
    "Pool": "Pool",
    "WiFi": "WiFi",
    "Air Conditioning": "Air Conditioning",
    "Fully Equipped Kitchen": "Fully Equipped Kitchen",
    "Terrace": "Terrace",
    "Parking": "Parking",
    "TV": "TV",
    "Washing Machine": "Washing Machine",
    "Near Beach (10 min walk)": "Near Beach (10 min walk)",
    "Near Shopping Centre (15 min walk)": "Near Shopping Centre (15 min walk)",
  },
  is: {
    "Pool": "Sundlaug",
    "WiFi": "WiFi",
    "Air Conditioning": "Loftkæling",
    "Fully Equipped Kitchen": "Fullbúið eldhús",
    "Terrace": "Verönd",
    "Parking": "Bílastæði",
    "TV": "Sjónvarp",
    "Washing Machine": "Þvottavél",
    "Near Beach (10 min walk)": "Nálægt strönd (10 mín ganga)",
    "Near Shopping Centre (15 min walk)": "Nálægt verslunarmiðstöð (15 mín ganga)",
  },
  lt: {
    "Pool": "Baseinas",
    "WiFi": "WiFi",
    "Air Conditioning": "Oro kondicionierius",
    "Fully Equipped Kitchen": "Pilnai įrengta virtuvė",
    "Terrace": "Terasa",
    "Parking": "Parkavimas",
    "TV": "Televizorius",
    "Washing Machine": "Skalbimo mašina",
    "Near Beach (10 min walk)": "Netoli paplūdimio (10 min pėsčiomis)",
    "Near Shopping Centre (15 min walk)": "Netoli prekybos centro (15 min pėsčiomis)",
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem("preferredLanguage");
    return saved || "en";
  });

  useEffect(() => {
    localStorage.setItem("preferredLanguage", language);
  }, [language]);

  const t = (key, params = {}) => {
    let text = translations[language][key] || translations["en"][key] || key;
    Object.keys(params).forEach((param) => {
      text = text.replace(`{${param}}`, params[param]);
    });
    return text;
  };

  const translateAmenity = (amenity) => {
    return amenityTranslations[language]?.[amenity] || amenityTranslations["en"]?.[amenity] || amenity;
  };

  const cycleLanguage = () => {
    const languages = ["en", "is", "lt"];
    const currentIndex = languages.indexOf(language);
    const nextIndex = (currentIndex + 1) % languages.length;
    setLanguage(languages[nextIndex]);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, translateAmenity, cycleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
